// @ts-nocheck
/**
 * Marketing site event type constants
 */
export const MARKETING_EVENTS = {
  // ===== Automatic Events =====

  // Page views (tracked automatically via gatsby-browser.js)
  PAGE_VIEW: 'page.view',

  // Scroll depth (tracked automatically at 25%, 50%, 75%, 100%)
  SCROLL_DEPTH: 'scroll.depth',

  // Time on page (tracked automatically at 10s, 30s, 60s, 120s)
  TIME_ON_PAGE: 'engagement.time_on_page',

  // Exit intent (tracked automatically when mouse leaves viewport)
  EXIT_INTENT: 'exit_intent.triggered',

  // ===== Conversion Funnel Events =====

  // CTA clicks (manual tracking in components)
  CTA_SIGNUP: 'cta.click.signup',
  CTA_LOGIN: 'cta.click.login',

  // Pricing interactions
  PRICING_VIEWED: 'pricing.plan.viewed',
  PRICING_SELECTED: 'pricing.plan.selected',
  PRICING_COMPARED: 'pricing.plan.compared',

  // Form interactions (venue signup)
  FORM_STARTED: 'form.venue_signup.started',
  FORM_FIELD_COMPLETED: 'form.venue_signup.field_completed',
  FORM_SUBMITTED: 'form.venue_signup.submitted',
  FORM_ERROR: 'form.venue_signup.error',

  // ===== Navigation Events =====

  // Navigation clicks
  NAV_MENU_CLICK: 'navigation.menu.click',
  NAV_FOOTER_CLICK: 'navigation.footer.click',
  LANGUAGE_CHANGE: 'navigation.language.change',
  OUTBOUND_LINK: 'link.outbound.click',

  // ===== Engagement Events =====

  // FAQ interactions
  FAQ_OPENED: 'faq.item.opened',
  FAQ_CLOSED: 'faq.item.closed',

  // Feature section engagement
  FEATURE_VIEWED: 'feature.viewed',
  FEATURE_CLICKED: 'feature.clicked',

  // Testimonial engagement
  TESTIMONIAL_VIEWED: 'testimonial.viewed',

  // ===== Media & Resources =====

  // Video interactions (if videos added)
  VIDEO_PLAY: 'video.play',
  VIDEO_PAUSE: 'video.pause',
  VIDEO_COMPLETE: 'video.complete',

  // Resource downloads (if PDFs/guides added)
  RESOURCE_DOWNLOAD: 'resource.download',

  // ===== Attribution =====

  // Signup attribution tracking
  SIGNUP_ATTRIBUTION: 'signup.attribution',
};
